import AppDownloadPromptModal from '@/features/app-download-prompt/AppDownloadPromptModal';
import { useAppSelector } from '@/hooks';
import FavoritesLoginModal from './LoginModal';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

/** What a logged-out visitor gets on tapping the favourite heart. */
const LoggedOutFavouriteModal = ({ isOpen, onClose }: Props) => {
  const isWhitelabel = useAppSelector((state) => state?.settings.isWhitelabel);

  // A salon's white-label site never sends its visitors to the Bokadirekt app.
  if (isWhitelabel) return <FavoritesLoginModal isOpen={isOpen} onClose={onClose} />;

  return <AppDownloadPromptModal isOpen={isOpen} onClose={onClose} />;
};

export default LoggedOutFavouriteModal;
